namespace GeniuzPOS.InventoryReport {
    export interface IcReport02Row {
        Id?: string;
        SkuCode?: string;
        StkUnit?: string;
        SkuDesc?: string;
        SkuEnDesc?: string;
        WhsId?: string;
        WhsName?: string;
        WhsType?: number;
        ShopId?: string;
        ShopTypeId?: string;
        ShopGroupId?: string;
        ShopName?: string;
        QtyOnhand?: number;
        StockCostValue?: number;
        CatCode?: string;
        CatName?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        BrandCode?: string;
        BrandName?: string;
        StyleId?: string;
        StyleName?: string;
        ColorId?: string;
        ColorName?: string;
        SizeId?: string;
        SizeName?: string;
        TasteId?: string;
        TasteName?: string;
        MatTypeId?: string;
        MatTypeName?: string;
        SupplId?: string;
        SupplName?: string;
        StockFg?: number;
        ConsignFg?: ConsignFg;
    }

    export namespace IcReport02Row {
        export const idProperty = 'Id';
        export const nameProperty = 'SkuCode';
        export const localTextPrefix = 'InventoryReport.IcReport02';
        export const deletePermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';
        export const insertPermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';
        export const readPermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';
        export const updatePermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';

        export declare const enum Fields {
            Id = "Id",
            SkuCode = "SkuCode",
            StkUnit = "StkUnit",
            SkuDesc = "SkuDesc",
            SkuEnDesc = "SkuEnDesc",
            WhsId = "WhsId",
            WhsName = "WhsName",
            WhsType = "WhsType",
            ShopId = "ShopId",
            ShopTypeId = "ShopTypeId",
            ShopGroupId = "ShopGroupId",
            ShopName = "ShopName",
            QtyOnhand = "QtyOnhand",
            StockCostValue = "StockCostValue",
            CatCode = "CatCode",
            CatName = "CatName",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            StyleId = "StyleId",
            StyleName = "StyleName",
            ColorId = "ColorId",
            ColorName = "ColorName",
            SizeId = "SizeId",
            SizeName = "SizeName",
            TasteId = "TasteId",
            TasteName = "TasteName",
            MatTypeId = "MatTypeId",
            MatTypeName = "MatTypeName",
            SupplId = "SupplId",
            SupplName = "SupplName",
            StockFg = "StockFg",
            ConsignFg = "ConsignFg"
        }
    }
}
